// extracted by mini-css-extract-plugin
export default {"blockCircle":"StatusIndicator_blockCircle__dLJzO","circle":"StatusIndicator_circle__KMl1P"};